var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.78337L2.79998 6.08335L3.71345 5.14345L5.85 7.28V0H7.15V7.28L9.28655 5.14345L10.2 6.08335L6.5 9.78337ZM1.56672 13C1.12891 13 0.758333 12.8483 0.455 12.545C0.151667 12.2417 0 11.8711 0 11.4333V9.08332H1.3V11.4333C1.3 11.5 1.32781 11.5611 1.38342 11.6166C1.43888 11.6722 1.49998 11.7 1.56672 11.7H11.4333C11.5 11.7 11.5611 11.6722 11.6166 11.6166C11.6722 11.5611 11.7 11.5 11.7 11.4333V9.08332H13V11.4333C13 11.8711 12.8483 12.2417 12.545 12.545C12.2417 12.8483 11.8711 13 11.4333 13H1.56672Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.06c10b035a04e5da09f00fbdf76ab52e.svg";
export { ForwardRef as ReactComponent };